
import {
  defineComponent,
  computed,
} from 'vue';

export default defineComponent({
  props: {
    href: {
      type: String,
      required: false,
      default: () => null,
    },
    target: {
      type: String,
      required: false,
      default: () => '_blank',
    },
    inverted: {
      type: String,
      required: false,
      default: () => '0',
    },
    marginTop: {
      type: String,
      required: false,
      default: () => 'default',
    },
    marginBottom: {
      type: String,
      required: false,
      default: () => 'default',
    },
  },

  setup(props) {
    const wrapperClasses = computed<string[]>(() => {
      const wrapperClassesComputed: string[] = [];

      if (props.marginTop === 'none') {
        wrapperClassesComputed.push('pt-0');
      }

      if (props.marginBottom === 'none') {
        wrapperClassesComputed.push('pb-0');
      }

      return wrapperClassesComputed;
    });

    const btnClasses = computed<string[]>(() => {
      const btnClassesComputed: string[] = [];

      if (props.inverted === '1') {
        btnClassesComputed.push('inv');
      }

      if (props.marginTop === 'none') {
        btnClassesComputed.push('mt-0');
      }

      return btnClassesComputed;
    });

    return {
      btnClasses,
      wrapperClasses,
    };
  },
});
